import { Box, createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { RpiLabelText } from "@rpi/openapi-core";
import { getDisplayName, getProductImage } from "./attributeValueMappings";

export type ProductImageProps = {
  displayName: string;
  image: string;
};

const useProductImageStyles = createStyles(() => ({
  container: {
    position: "relative",
    display: "inline-block",
    width: 312,
    height: 312,
    pointerEvents: "none",
  },
  image: {
    width: "100%",
    height: "100%",
    borderRadius: "var(--codex-radius-md)",
    display: "block",
  },
  labelBox: {
    position: "absolute",
    borderRadius: "var(--codex-radius-md)",
    top: 0,
    left: 0,
    backgroundColor: tokens.color.semantic.bg.neutralSelected,
    margin: "var(--codex-spacing-4)",
    padding: "var(--codex-spacing-1) var(--codex-spacing-2)",
    fontSize: "var(--codex-font-size-sm)",
  },
}));

export const defaultProductImageConfig =
  (attributeKey: string): ((value: string) => ProductImageProps | undefined) =>
  (value): ProductImageProps | undefined => {
    if (!attributeKey) return undefined;

    const displayName = getDisplayName(attributeKey, String(value));
    const image = getProductImage(attributeKey, String(value));

    if (!displayName || !image) return undefined;

    return {
      displayName,
      image,
    };
  };

export const ProductImage = ({ displayName, image }: ProductImageProps) => {
  const { classes } = useProductImageStyles();

  return (
    <Box className={classes.container}>
      <img src={image} alt={displayName} className={classes.image} />
      <Box className={classes.labelBox}>
        <RpiLabelText>{displayName}</RpiLabelText>
      </Box>
    </Box>
  );
};
